export class ResetPasswordDTO {
  constructor(
    public password: string,
    public confirm_password: string,
    public user_id: number
  ) {}
}
